export default __webpack_public_path__ + "static/media/Digital-marketingCr.ca621fe8.png";